import React, { useRef, forwardRef, useEffect } from 'react';
import ProTable from '@ant-design/pro-table';
import { Popconfirm, message } from 'antd';
import { rightsUnbound, queryRelationPageList } from '@/services/operating';

const RelativeView = (props, ref) => {
  // eslint-disable-next-line react/prop-types
  console.log('RelativeView props:', props);
  const { userId } = props;
  const relativeTableRef = useRef();

  const relativeTableColumns = [
    {
      title: '商品权益',
      width: 80,
      dataIndex: 'goodsName',
    },
    {
      title: '手机号',
      width: 180,
      dataIndex: 'phone',
    },
    {
      title: '绑定方式',
      width: 180,
      dataIndex: 'bindingStatusName',
    },
    {
      title: '绑定时间',
      width: 180,
      dataIndex: 'bindingTime',
    },
    {
      title: '关联状态',
      width: 120,
      dataIndex: 'status',
      valueEnum: {
        0: {
          text: '管理员',
        },
        1: {
          text: '正常',
        },
        2: {
          text: '已解绑',
        },
        3: {
          text: '已失效',
        },
      },
    },
    {
      title: '解绑时间', // todo
      width: 180,
      dataIndex: 'unboundTime',
    },
    {
      title: '解绑方式',
      width: 120,
      dataIndex: 'unboundStatusName',
    },
    {
      title: '操作', // todo
      width: 120,
      // key: 'option',
      fixed: 'right',
      valueType: 'option',
      render: (t, r) => [
        r.status === 1 ? (
          <Popconfirm
            onConfirm={() => delRelativeAction(r)}
            title="你确定要解绑吗？"
            okText="确定"
            cancelText="取消"
            key={'options'}
          >
            {r.bindingStatus !== 0 ? <a key="link">解绑</a> : ''}
          </Popconfirm>
        ) : (
          ''
        ),
      ],
    },
  ];

  // 解绑
  const delRelativeAction = async (r) => {
    const { code, msg } = await rightsUnbound({
      requestData: {
        userId: r.userId,
        poolId: r.poolId,
      },
    });
    if (code !== '00000') {
      message.error(msg);
    } else {
      message.success('解绑成功！');
      relativeTableRef.current.reload();
    }
  };

  useEffect(() => {
    // 设置成属性 js太6了
    ref.current.tableRef = relativeTableRef;
  }, []);

  return (
    <div ref={ref}>
      <ProTable
        columns={relativeTableColumns}
        actionRef={relativeTableRef}
        request={async (params) => {
          const { data, page, code } = await queryRelationPageList({
            requestData: {
              userId: userId,
            },
            page: {
              currentPage: params.current,
              pageSize: params.pageSize,
            },
          });
          if (code !== '00000') {
            return {
              success: false,
            };
          }
          return {
            data: data,
            success: true,
            total: page.count,
          };
        }}
        columnsState={{
          persistenceKey: 'pro-table-singe-demos2',
          persistenceType: 'localStorage',
        }}
        // rowKey={(record) => record.id}
        rowKey="id"
        search={false}
        scroll={{ x: 'max-content' }}
        pagination={{
          defaultPageSize: 10,
        }}
        dateFormatter="string"
        toolBarRender={false}
      />
    </div>
  );
};

export default forwardRef(RelativeView);
